<app-dialog-header [title]="'Cadastrar portador do ingresso'" [disabled]="isLoading"></app-dialog-header>

<mat-dialog-content>
  <div class="">
    <div class="card-body">
      <form [formGroup]="assignForm" style="margin-top: 1em; display: grid; gap: 1em">
        <div class="alert alert-info">
          <p class="h4">Cadastrar dados do ingresso</p>
          <ol>
            <li>Revise os dados com atenção! Certifique-se de que todas as informações estão corretas.</li>
            <li>Clique em "Salvar".</li>
            <li>O ingresso continuará disponível na sua conta, na área "Meus Ingressos".</li>
          </ol>
        </div>
        <div class="form-group">
          <label for="user_email">Email:</label>
          <input
            type="email"
            id="user_email"
            name="user_email"
            [readonly]="assignForm.get('user_email')?.valid"
            class="form-control"
            formControlName="user_email"
            [ngClass]="{
              'is-invalid': assignForm.get('user_email')?.invalid,
            }" />
          @if (assignForm.get('user_email')?.invalid) {
            <div class="invalid-feedback">
              @if (assignForm.get('user_email')?.errors?.['required']) {
                <span>
                  {{ "Campo email é obrigatório" }}
                </span>
              }
              @if (assignForm.get('user_email')?.errors?.['email']) {
                <span> Formato de e-mail inválido. </span>
              }
            </div>
          }
        </div>

        <div class="form-group">
          <label for="user_name">Nome:</label>
          <input
            type="text"
            id="user_name"
            name="user_name"
            class="form-control"
            formControlName="user_name"
            [ngClass]="{
              'is-invalid': assignForm.get('user_name')?.invalid,
            }" />
          @if (assignForm.get('user_name')?.invalid) {
            <div class="invalid-feedback">
              @if (assignForm.get('user_name')?.errors?.['required']) {
                <span> Campo nome é obrigatório </span>
              }
              @if (assignForm.get('user_name')?.errors?.['invalidName']) {
                <span>
                  Você deve inserir nome e sobrenome
                </span>
              }
            </div>
          }
        </div>

        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="isForeigner" formControlName="isForeigner" />
          <label class="form-check-label ms-2" for="isForeigner"> É estrangeiro? </label>
        </div>

        @if (assignForm.get("isForeigner")?.value) {
          <div class="mb-3">
            <label for="identity_card" class="form-label">Documento de identidade (estrangeiro)</label>
            <input
              type="text"
              class="form-control"
              id="identity_card"
              placeholder="passaporte, DNI, RNE…"
              formControlName="user_identity_card"
              [class.is-invalid]="
                assignForm.get('user_identity_card')?.invalid && assignForm.get('user_identity_card')?.touched
              " />
            @if (assignForm.get('user_identity_card')?.invalid && assignForm.get('user_identity_card')?.touched) {
              <div
                class="invalid-feedback">
                @if (assignForm.get('user_identity_card')?.errors?.['required']) {
                  <span>
                    Campo de documento internacional está vazio
                  </span>
                }
              </div>
            }
          </div>
        } @else {
          <div class="form-group">
            <label for="user_cpf">CPF:</label>
            <input
              type="text"
              id="user_cpf"
              name="user_cpf"
              class="form-control"
              formControlName="user_cpf"
              mask="000.000.000-00"
              [ngClass]="{
                'is-invalid': assignForm.get('user_cpf')?.invalid && assignForm.get('user_cpf')?.touched,
              }" />
            @if (assignForm.get('user_cpf')?.invalid && assignForm.get('user_cpf')?.touched) {
              <div
                class="invalid-feedback">
                <!-- Mensagem de erro caso o campo esteja vazio -->
                @if (assignForm.get('user_cpf')?.errors?.['required']) {
                  <span>
                    {{ "Campo CPF é obrigatório" }}
                  </span>
                }
                @if (assignForm.get('user_cpf')?.errors?.['cpfInvalid']) {
                  <span>
                    {{ "CPF inválido" }}
                  </span>
                }
              </div>
            }
          </div>
        }
      </form>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="gap-2">
  <app-button type="button" styleType="secondary" (btnClick)="dialogRef.close()" [disabled]="isLoading"
    >Cancelar</app-button
    >
    <app-button (btnClick)="onSubmitAssign()" [disabled]="isLoading"> Salvar </app-button>
  </mat-dialog-actions>
